// extracted by mini-css-extract-plugin
export default {"actions":"_637b38e9e98e5899","action":"_4435528bd83d92e4","approvalCommentCommentCell":"_4a1a1b0624c80f3e"};